<div data-testid="sidebar-container" class="relative h-full">
  @if (sidebarService.isResponsive() && sidebarService.isOpen()) {
    <div
      data-testid="sidebar-mobile-backdrop"
      class="fixed inset-0 bg-black/30 z-[190] transition-opacity"
      (click)="onToggle()"
      aria-hidden="true"
    ></div>
  }
  <nav
    data-testid="sidebar-nav"
    #sidebar
    class="border-r border-gray-200 transition-all bg-white h-full flex flex-col overflow-x-hidden"
    [class]="
      sidebarService.isOpen()
        ? sidebarService.isResponsive()
          ? 'mobile-drawer-open w-[250px]'
          : 'relative w-[250px]'
        : 'relative w-14'
    "
    [class.sidebar-resizing]="sidebarService.isResizing()"
    [style.width.px]="
      sidebarService.isOpen() && !sidebarService.isResponsive()
        ? sidebarService.sidebarWidth()
        : null
    "
    (mouseleave)="onSidebarLeave()"
  >
    <header
      class="sidebar-header flex items-center"
      [ngClass]="
        sidebarService.isOpen()
          ? 'h-16 gap-3 px-4 py-3 justify-between'
          : 'min-h-16 py-2 px-1 flex-col gap-1 justify-center'
      "
    >
      <div
        class="flex items-center"
        [ngClass]="
          sidebarService.isOpen()
            ? 'gap-2.5 h-full'
            : 'flex-col gap-1 justify-center w-full'
        "
        (mouseenter)="onLogoHover()"
        (mouseleave)="onLogoLeave()"
      >
        <!-- When sidebar is open -->
        @if (sidebarService.isOpen()) {
          <div
            data-testid="sidebar-logo-home-btn"
            class="flex items-center gap-2.5 cursor-pointer"
            (click)="navigateToHomepage()"
          >
            <img
              src="assets/images/logo-menu.jpg"
              alt="Unified Retail"
              class="object-cover"
              [ngClass]="sidebarService.isOpen() ? 'w-9' : 'w-8'"
            />
            <span class="sidebar-brand-title whitespace-nowrap">
              Unified Retail
            </span>
          </div>
        }

        <!-- When sidebar is closed: always render touch-accessible expand button -->
        @if (!sidebarService.isOpen()) {
          <img
            src="assets/images/logo-menu.jpg"
            alt="Unified Retail"
            class="object-cover w-8 cursor-pointer"
            (click)="onToggle()"
          />
          <button
            data-testid="sidebar-open-btn"
            type="button"
            class="material-symbols-outlined text-gray-600 text-sm cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-md border border-gray-200 p-1 flex items-center justify-center"
            (click)="onToggle()"
            [attr.aria-label]="'sidebar.ui.open_menu' | translate"
            [attr.title]="'sidebar.ui.open_menu' | translate"
          >
            chevron_right
          </button>
        }
      </div>

      <!-- Toggle button -->
      @if (sidebarService.isOpen()) {
        <button
          data-testid="sidebar-toggle-btn"
          type="button"
          class="ml-2 rounded-md hover:bg-gray-100 sidebar-toggle-btn p-1"
          (click)="onToggle()"
          [attr.aria-label]="'sidebar.ui.close_menu' | translate"
        >
          <span class="material-symbols-outlined text-gray-500 text-sm">
            chevron_left
          </span>
        </button>
      }
    </header>
    @if (sidebarService.isOpen() && showTenantSwitcher()) {
      <div class="px-3 pb-2 tenant-switcher-wrapper">
        <app-tenant-switcher />
      </div>
    }

    <div class="flex-1 overflow-y-auto overflow-x-hidden sidebar-scroll">
      <div
        class="space-y-1"
        [ngClass]="sidebarService.isOpen() ? 'px-2.5 py-1' : 'px-1'"
      >
        @for (item of items; track item.label) {
          <div class="relative">
            <!-- Main menu item -->
            <button
              [attr.data-testid]="
                'sidebar-menu-' + toTestId(item['name'] || item.label) + '-btn'
              "
              type="button"
              class="sidebar-main-item flex items-center py-2 w-full rounded-lg transition-colors group relative border-none text-left"
              [ngClass]="[
                sidebarService.isOpen() ? 'gap-2.5 px-3' : 'justify-center',
                item.disabled
                  ? 'cursor-not-allowed text-gray-400'
                  : 'cursor-pointer menu-item-hover',
                (isMenuActive(item) || item.expanded) && !item.disabled
                  ? 'sidebar-main-item-active bg-blue-50 text-blue-600 font-medium'
                  : item.disabled
                    ? 'text-gray-400 bg-transparent'
                    : 'bg-transparent hover:bg-gray-100 text-gray-700',
              ]"
              [disabled]="item.disabled"
              (click)="!item.disabled && toggleMenuItem(item)"
              (mouseenter)="!item.disabled && onMenuItemHover(item, $event)"
              (mouseleave)="!item.disabled && onMenuItemLeave(item, $event)"
              (keydown.enter)="!item.disabled && toggleMenuItem(item)"
              (keydown.space)="!item.disabled && toggleMenuItem(item)"
            >
              @if (!sidebarService.isOpen()) {
                <span
                  class="material-symbols-outlined text-[20px] flex-shrink-0 p-0.5"
                  [ngClass]="
                    isMenuActive(item) || item.expanded
                      ? 'text-blue-600'
                      : 'text-gray-600'
                  "
                >
                  {{ item.icon }}
                </span>
              }
              @if (sidebarService.isOpen()) {
                <span
                  class="material-symbols-outlined text-[20px] flex-shrink-0"
                  [ngClass]="
                    isMenuActive(item) || item.expanded
                      ? 'text-blue-600'
                      : 'text-gray-600'
                  "
                >
                  {{ item.icon }}
                </span>
                <span class="flex-1 text-left menu-item-text">
                  {{ item.label | translate }}
                </span>
                <span
                  class="material-symbols-outlined text-[18px] transition-transform"
                  [ngClass]="[
                    item.expanded ? 'rotate-90' : '',
                    isMenuActive(item) || item.expanded
                      ? 'text-blue-600'
                      : 'text-gray-400',
                  ]"
                >
                  chevron_right
                </span>
              }
            </button>

            <!-- Submenu (expanded state) -->
            @if (sidebarService.isOpen() && item.expanded && item.items) {
              <div class="sidebar-submenu-tree mt-1 mb-1">
                @for (subItem of item.items[0]; track subItem.label) {
                  <div class="sidebar-submenu-node relative">
                    @if (subItem.items) {
                      <!-- Submenu with children -->
                      <button
                        [attr.data-testid]="
                          'sidebar-submenu-' +
                          toTestId(subItem['name'] || subItem.label) +
                          '-btn'
                        "
                        type="button"
                        class="sidebar-sub-btn flex items-center py-1.5 px-3 w-full rounded-lg transition-colors group border-none text-left"
                        [ngClass]="[
                          subItem.disabled
                            ? 'cursor-not-allowed text-gray-400'
                            : 'cursor-pointer',
                          isFirstChildActive(subItem, item) && !subItem.disabled
                            ? 'sidebar-sub-btn-active bg-blue-50 text-blue-700 font-medium'
                            : subItem.disabled
                              ? 'text-gray-400'
                              : 'hover:bg-gray-50 text-gray-600 bg-transparent',
                        ]"
                        [disabled]="subItem.disabled"
                        (click)="
                          !subItem.disabled && toggleSubMenuItem(subItem)
                        "
                        (mouseenter)="
                          !subItem.disabled &&
                            onSubMenuItemHover(subItem, item, $event)
                        "
                        (mouseleave)="
                          !subItem.disabled &&
                            onSubMenuItemLeave(subItem, $event)
                        "
                        (keydown.enter)="
                          !subItem.disabled && toggleSubMenuItem(subItem)
                        "
                        (keydown.space)="
                          !subItem.disabled && toggleSubMenuItem(subItem)
                        "
                      >
                        <span
                          class="flex-1 text-left text-sm submenu-item-text"
                          >{{ subItem.label | translate }}</span
                        >
                        <span
                          class="material-symbols-outlined text-gray-400 text-xs transition-transform"
                          [ngClass]="subItem.expanded ? 'rotate-90' : ''"
                        >
                          chevron_right
                        </span>
                      </button>

                      <!-- Sub-submenu -->
                      @if (subItem.expanded && subItem.items) {
                        <div class="sidebar-submenu-tree sidebar-submenu-tree-nested mt-1">
                          @for (
                            subSubItem of subItem.items;
                            track subSubItem.label
                          ) {
                            <div class="sidebar-submenu-node relative">
                              <button
                                [attr.data-testid]="
                                  'sidebar-submenu-child-' +
                                  toTestId(subSubItem['name'] || subSubItem.label) +
                                  '-btn'
                                "
                                type="button"
                                class="sidebar-sub-btn flex items-center py-1.5 px-3 w-full rounded-lg transition-colors text-sm submenu-item-text bg-transparent border-none text-left"
                                [ngClass]="[
                                  subSubItem.disabled
                                    ? 'cursor-not-allowed text-gray-400 opacity-50'
                                    : 'cursor-pointer',
                                  isSecondChildActive(
                                    subSubItem,
                                    subItem,
                                    item
                                  ) && !subSubItem.disabled
                                    ? 'sidebar-sub-btn-active bg-blue-50 text-blue-700 font-medium'
                                    : subSubItem.disabled
                                      ? 'text-gray-400 opacity-50 bg-transparent'
                                      : isMenuItemActive(subSubItem)
                                        ? 'hover:bg-gray-50 text-gray-700 bg-transparent'
                                        : 'hover:bg-gray-50 text-gray-700 bg-transparent',
                                ]"
                                [disabled]="subSubItem.disabled"
                                (click)="
                                  !subSubItem.disabled &&
                                    handleMenuItemClick(subSubItem)
                                "
                                (keydown.enter)="
                                  !subSubItem.disabled &&
                                    handleMenuItemClick(subSubItem)
                                "
                                (keydown.space)="
                                  !subSubItem.disabled &&
                                    handleMenuItemClick(subSubItem)
                                "
                              >
                                {{ subSubItem.label | translate }}
                              </button>
                            </div>
                          }
                        </div>
                      }
                    } @else {
                      <!-- Direct submenu item -->
                      <button
                        [attr.data-testid]="
                          'sidebar-submenu-item-' +
                          toTestId(subItem['name'] || subItem.label) +
                          '-btn'
                        "
                        type="button"
                        class="sidebar-sub-btn flex items-center py-1.5 px-3 w-full rounded-lg transition-colors text-sm submenu-item-text border-none text-left"
                        [ngClass]="[
                          subItem.disabled
                            ? 'cursor-not-allowed text-gray-400 opacity-50'
                            : 'cursor-pointer',
                          isFirstChildActive(subItem, item) && !subItem.disabled
                            ? 'sidebar-sub-btn-active bg-blue-50 text-blue-700 font-medium'
                            : subItem.disabled
                              ? 'text-gray-400 opacity-50 bg-transparent'
                              : isMenuItemActive(subItem)
                                ? 'hover:bg-gray-50 text-gray-700 bg-transparent'
                                : 'hover:bg-gray-50 text-gray-700 bg-transparent',
                        ]"
                        [disabled]="subItem.disabled"
                        (click)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                        (keydown.enter)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                        (keydown.space)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                      >
                        <span class="flex-1">{{
                          subItem.label | translate
                        }}</span>
                      </button>
                    }
                  </div>
                }
              </div>
            }

            <!-- Floating submenu (collapsed state) - GitLab style -->
            @if (
              !sidebarService.isOpen() && item["showFloatingMenu"] && item.items
            ) {
              <div
                [attr.data-testid]="
                  'sidebar-floating-menu-' + toTestId(item['name'] || item.label)
                "
                class="absolute left-full top-0 ml-3 bg-white border border-gray-200 rounded-lg shadow-xl z-50 min-w-[220px] max-w-[280px] floating-menu"
                (mouseenter)="onFloatingMenuHover(item)"
                (mouseleave)="onFloatingMenuLeave(item)"
                style="
                  box-shadow:
                    0 20px 25px -5px rgba(0, 0, 0, 0.1),
                    0 10px 10px -5px rgba(0, 0, 0, 0.04);
                "
              >
                <!-- Arrow pointing to the menu item -->
                <div
                  class="absolute -left-2 top-4 w-0 h-0 border-t-8 border-b-8 border-r-8 border-transparent border-r-gray-200"
                ></div>
                <div
                  class="absolute -left-1.5 top-4.5 w-0 h-0 border-t-7 border-b-7 border-r-7 border-transparent border-r-white"
                ></div>

                <div class="p-3">
                  <!-- Header with icon and title -->
                  <div class="flex items-center gap-2 mb-3 px-1">
                    @if (!sidebarService.isOpen()) {
                      <span
                        class="material-symbols-outlined text-gray-600 text-[20px]"
                      >
                        {{ item.icon }}
                      </span>
                    }
                    <div
                      class="text-sm font-semibold text-gray-800 menu-item-text"
                    >
                      {{ item.label | translate }}
                    </div>
                  </div>

                  <!-- Menu items -->
                  <div class="space-y-0.5">
                    @for (subItem of item.items[0]; track subItem.label) {
                      <button
                        [attr.data-testid]="
                          'sidebar-floating-menu-item-' +
                          toTestId(subItem['name'] || subItem.label) +
                          '-btn'
                        "
                        type="button"
                        class="px-3 py-2 text-sm rounded-md transition-colors floating-menu-item border-none text-left w-full"
                        [ngClass]="[
                          subItem.disabled
                            ? 'cursor-not-allowed text-gray-400 opacity-50'
                            : 'cursor-pointer hover:bg-gray-50',
                          isFirstChildActive(subItem, item) && !subItem.disabled
                            ? 'text-blue-600 bg-blue-50 font-medium border-l-4 border-blue-500'
                            : subItem.disabled
                              ? 'text-gray-400 opacity-50 bg-transparent'
                              : isMenuItemActive(subItem)
                                ? 'text-blue-600 bg-blue-50'
                                : 'text-gray-700 hover:text-gray-900 bg-transparent',
                        ]"
                        [disabled]="subItem.disabled"
                        (click)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                        (keydown.enter)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                        (keydown.space)="
                          !subItem.disabled && handleMenuItemClick(subItem)
                        "
                      >
                        <span class="flex-1">{{
                          subItem.label | translate
                        }}</span>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Custom Hover Panel for Collapsed Sidebar Items with Children -->
    @if (tieredMenuVisible && hoveredItem) {
      <div
        [attr.data-testid]="
          'sidebar-hover-panel-' +
          toTestId(hoveredItem['name'] || hoveredItem.label)
        "
        class="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-3 w-auto max-w-[250px] panel-container"
        [style.left.px]="tieredMenuPosition.x"
        [style.top.px]="tieredMenuPosition.y"
        (mouseenter)="onPanelHover()"
        (mouseleave)="onPanelLeave()"
      >
        <!-- Panel Header - Only show when sidebar is collapsed -->
        @if (!sidebarService.isOpen()) {
          <div
            class="flex items-center gap-2 mb-2 pb-2 border-b border-gray-100"
          >
            <span class="material-symbols-outlined text-gray-600 text-sm">
              {{ hoveredItem.icon }}
            </span>
            <div class="text-sm font-semibold text-gray-800">
              {{ hoveredItem.label | translate }}
            </div>
          </div>
        }

        <!-- Panel Items -->
        <div class="space-y-1">
          @for (subItem of hoveredItem.items?.[0]; track subItem.label) {
            <button
              [attr.data-testid]="
                'sidebar-hover-panel-item-' +
                toTestId(subItem['name'] || subItem.label) +
                '-btn'
              "
              type="button"
              class="w-full text-left px-2 py-1.5 text-sm rounded transition-colors border-none panel-item"
              [ngClass]="[
                subItem.disabled
                  ? 'cursor-not-allowed text-gray-400 opacity-50 bg-transparent'
                  : isPanelItemActive(subItem)
                    ? 'cursor-pointer bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-medium'
                    : 'cursor-pointer text-gray-700 hover:bg-gray-50 bg-transparent',
              ]"
              [disabled]="subItem.disabled"
              (click)="!subItem.disabled && handleMenuItemClick(subItem)"
            >
              <span class="panel-item-text">{{
                subItem.label | translate
              }}</span>
            </button>
          }
        </div>
      </div>
    }

    <!-- First Level Panel for Setting Menu -->
    @if (firstLevelPanelVisible && firstLevelHoveredItem) {
      <div
        [attr.data-testid]="
          'sidebar-first-level-panel-' +
          toTestId(firstLevelHoveredItem['name'] || firstLevelHoveredItem.label)
        "
        class="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-3 w-auto max-w-[250px] panel-container"
        [style.left.px]="firstLevelPanelPosition.x"
        [style.top.px]="firstLevelPanelPosition.y"
        (mouseenter)="onFirstLevelPanelHover()"
        (mouseleave)="onFirstLevelPanelLeave()"
      >
        <!-- First Level Panel Items -->
        <div class="space-y-1">
          @for (
            subItem of firstLevelHoveredItem.items?.[0];
            track subItem.label
          ) {
            <button
              [attr.data-testid]="
                'sidebar-first-level-panel-item-' +
                toTestId(subItem['name'] || subItem.label) +
                '-btn'
              "
              type="button"
              class="w-full text-left px-2 py-1.5 text-sm rounded transition-colors border-none flex items-center justify-between panel-item"
              [ngClass]="[
                subItem.disabled
                  ? 'cursor-not-allowed text-gray-400 opacity-50 bg-transparent'
                  : isFirstLevelPanelItemActive(subItem)
                    ? 'cursor-pointer bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-medium'
                    : 'cursor-pointer text-gray-700 hover:bg-gray-50 bg-transparent',
              ]"
              [disabled]="subItem.disabled"
              (click)="!subItem.disabled && handleMenuItemClick(subItem)"
              (mouseenter)="
                !subItem.disabled && onFirstLevelItemHover(subItem, $event)
              "
              (mouseleave)="!subItem.disabled && onFirstLevelItemLeave(subItem)"
            >
              <span class="panel-item-text">{{
                subItem.label | translate
              }}</span>
              @if (subItem.items && subItem.items.length > 0) {
                <span
                  class="material-symbols-outlined text-gray-400 text-sm flex-shrink-0 ml-2"
                  >chevron_right</span
                >
              }
            </button>
          }
        </div>
      </div>
    }

    <!-- Second Level Panel for Nested Items -->
    @if (secondLevelPanelVisible && secondLevelHoveredItem) {
      <div
        [attr.data-testid]="
          'sidebar-second-level-panel-' +
          toTestId(secondLevelHoveredItem['name'] || secondLevelHoveredItem.label)
        "
        class="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-3 w-auto max-w-[250px] panel-container"
        [style.left.px]="secondLevelPanelPosition.x"
        [style.top.px]="secondLevelPanelPosition.y"
        (mouseenter)="onSecondLevelPanelHover()"
        (mouseleave)="onSecondLevelPanelLeave()"
      >
        <!-- Second Level Panel Items -->
        <div class="space-y-1">
          @for (
            subSubItem of secondLevelHoveredItem.items;
            track subSubItem.label
          ) {
            <button
              [attr.data-testid]="
                'sidebar-second-level-panel-item-' +
                toTestId(subSubItem['name'] || subSubItem.label) +
                '-btn'
              "
              type="button"
              class="w-full text-left px-2 py-1.5 text-sm rounded transition-colors border-none panel-item"
              [ngClass]="[
                subSubItem.disabled
                  ? 'cursor-not-allowed text-gray-400 opacity-50 bg-transparent'
                  : isSecondLevelPanelItemActive(subSubItem)
                    ? 'cursor-pointer bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-medium'
                    : 'cursor-pointer text-gray-700 hover:bg-gray-50 bg-transparent',
              ]"
              [disabled]="subSubItem.disabled"
              (click)="!subSubItem.disabled && handleMenuItemClick(subSubItem)"
            >
              <span class="panel-item-text">{{
                subSubItem.label | translate
              }}</span>
            </button>
          }
        </div>
      </div>
    }

    <!-- Collapsed Sidebar Panel -->
    @if (collapsedPanelVisible && collapsedPanelHoveredItem) {
      <div
        [attr.data-testid]="
          'sidebar-collapsed-panel-' +
          toTestId(
            collapsedPanelHoveredItem['name'] || collapsedPanelHoveredItem.label
          )
        "
        class="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-3 w-auto max-w-[250px] panel-container"
        [style.left.px]="collapsedPanelPosition.x"
        [style.top.px]="collapsedPanelPosition.y"
        (mouseenter)="onCollapsedPanelHover()"
        (mouseleave)="onCollapsedPanelLeave()"
      >
        <!-- First Level Panel Items (same as expanded sidebar) -->
        <div class="space-y-1">
          @if (
            collapsedPanelHoveredItem.items &&
            collapsedPanelHoveredItem.items[0]
          ) {
            @for (
              subItem of collapsedPanelHoveredItem.items[0];
              track subItem.label
            ) {
              <button
                [attr.data-testid]="
                  'sidebar-collapsed-panel-item-' +
                  toTestId(subItem['name'] || subItem.label) +
                  '-btn'
                "
                type="button"
                class="w-full text-left px-2 py-1.5 text-sm rounded transition-colors border-none flex items-center justify-between panel-item"
                [ngClass]="[
                  subItem.disabled
                    ? 'cursor-not-allowed text-gray-400 opacity-50 bg-transparent'
                    : isFirstLevelPanelItemActive(subItem)
                      ? 'cursor-pointer bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-medium'
                      : 'cursor-pointer text-gray-700 hover:bg-gray-50 bg-transparent',
                ]"
                [disabled]="subItem.disabled"
                (click)="!subItem.disabled && handleMenuItemClick(subItem)"
                (mouseenter)="
                  !subItem.disabled &&
                    onCollapsedFirstLevelItemHover(subItem, $event)
                "
                (mouseleave)="
                  !subItem.disabled && onCollapsedFirstLevelItemLeave(subItem)
                "
              >
                <span class="panel-item-text">{{
                  subItem.label | translate
                }}</span>
                @if (subItem.items && subItem.items.length > 0) {
                  <span
                    class="material-symbols-outlined text-gray-400 text-sm flex-shrink-0 ml-2"
                    >chevron_right</span
                  >
                }
              </button>
            }
          } @else {
            <div class="text-sm text-gray-500 px-2 py-1.5">
              No sub-items available
            </div>
          }
        </div>
      </div>
    }

    <!-- Collapsed Second Level Panel for Nested Items -->
    @if (collapsedSecondLevelPanelVisible && collapsedSecondLevelHoveredItem) {
      <div
        [attr.data-testid]="
          'sidebar-collapsed-second-level-panel-' +
          toTestId(
            collapsedSecondLevelHoveredItem['name'] ||
              collapsedSecondLevelHoveredItem.label
          )
        "
        class="fixed bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-3 w-auto max-w-[250px] panel-container"
        [style.left.px]="collapsedSecondLevelPanelPosition.x"
        [style.top.px]="collapsedSecondLevelPanelPosition.y"
        (mouseenter)="onCollapsedSecondLevelPanelHover()"
        (mouseleave)="onCollapsedSecondLevelPanelLeave()"
      >
        <!-- Second Level Panel Items -->
        <div class="space-y-1">
          @for (
            subSubItem of collapsedSecondLevelHoveredItem.items;
            track subSubItem.label
          ) {
            <button
              [attr.data-testid]="
                'sidebar-collapsed-second-level-panel-item-' +
                toTestId(subSubItem['name'] || subSubItem.label) +
                '-btn'
              "
              type="button"
              class="w-full text-left px-2 py-1.5 text-sm rounded transition-colors border-none panel-item"
              [ngClass]="[
                subSubItem.disabled
                  ? 'cursor-not-allowed text-gray-400 opacity-50 bg-transparent'
                  : isSecondLevelPanelItemActive(subSubItem)
                    ? 'cursor-pointer bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-medium'
                    : 'cursor-pointer text-gray-700 hover:bg-gray-50 bg-transparent',
              ]"
              [disabled]="subSubItem.disabled"
              (click)="!subSubItem.disabled && handleMenuItemClick(subSubItem)"
            >
              <span class="panel-item-text">{{
                subSubItem.label | translate
              }}</span>
            </button>
          }
        </div>
      </div>
    }

    <!-- User information section at bottom -->
    <div
      class="mt-auto border-t border-gray-200"
      [ngClass]="sidebarService.isOpen() ? 'p-3' : 'p-1'"
    >
      <div class="user-profile">
        <button
          data-testid="sidebar-user-menu-btn"
          type="button"
          class="user-profile-btn w-full flex items-center rounded-lg hover:bg-gray-100 transition-colors"
          [ngClass]="
            sidebarService.isOpen() ? 'gap-3 p-2' : 'p-1 justify-start'
          "
          (click)="userMenu.toggle($event)"
          #userMenuBtn
        >
          <!-- User avatar -->
          <div class="user-avatar relative flex-shrink-0">
            @if (userInfo().avatar) {
              <img
                data-testid="sidebar-user-avatar-img"
                [src]="userInfo().avatar"
                [alt]="userInfo().username"
                class="rounded-full object-cover flex-shrink-0"
                [ngClass]="sidebarService.isOpen() ? 'w-10 h-10' : 'w-8 h-8'"
              />
            } @else {
              <p-avatar
                data-testid="sidebar-user-avatar"
                [label]="getInitials()"
                size="normal"
                shape="circle"
                [styleClass]="
                  sidebarService.isOpen()
                    ? 'w-10 h-10 rounded-full flex-shrink-0'
                    : 'w-8 h-8 rounded-full flex-shrink-0'
                "
              />
            }
            <!-- Online status indicator -->
            <div
              data-testid="sidebar-user-online-status"
              class="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"
              [attr.aria-label]="'sidebar.ui.online' | translate"
            ></div>
          </div>

          @if (sidebarService.isOpen()) {
            <!-- User info -->
            <div class="user-info flex-1 text-left">
              <div class="user-name text-sm font-medium text-gray-900 truncate">
                {{ getDisplayName() }}
              </div>
              <div class="user-role text-xs text-gray-500 truncate">
                {{ translatedRole() }}
              </div>
            </div>
          }
          @if (sidebarService.isOpen()) {
            <!-- Dropdown arrow -->
            <i class="pi pi-chevron-down text-gray-400 text-xs"></i>
          }
        </button>
      </div>
    </div>
  </nav>
  @if (sidebarService.isOpen() && !sidebarService.isResponsive()) {
    <div
      data-testid="sidebar-resize-handle"
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize navigation sidebar"
      tabindex="0"
      class="sidebar-resize-handle"
      [class.sidebar-resize-handle-active]="sidebarService.isResizing()"
      (mousedown)="onSidebarResizeStart($event)"
      (dblclick)="onSidebarResizeReset()"
      (keydown)="onSidebarResizeKeydown($event)"
    ></div>
  }
</div>

<!-- User Menu Overlay -->
<p-popover
  data-testid="sidebar-user-menu-popover"
  #userMenu
  [dismissable]="true"
  styleClass="user-menu-popover"
>
  <div class="user-menu-content p-4 min-w-[280px]">
    <!-- User info section -->
    <div class="user-menu-header flex items-center gap-3 mb-4">
      <div class="user-menu-avatar">
        @if (userInfo().avatar) {
          <img
            data-testid="sidebar-user-menu-avatar-img"
            [src]="userInfo().avatar"
            [alt]="userInfo().username"
            class="w-12 h-12 rounded-full object-cover"
          />
        } @else {
          <p-avatar
            data-testid="sidebar-user-menu-avatar"
            [label]="getInitials()"
            size="large"
            shape="circle"
            styleClass="w-12 h-12"
          />
        }
      </div>
      <div class="user-menu-info">
        <div class="menu-user-name font-medium text-gray-900">
          {{ getDisplayName() }}
        </div>
        <div class="menu-user-email text-sm text-gray-500">
          {{ userInfo().email }}
        </div>
        <div class="menu-user-role text-xs text-gray-400">
          {{ translatedRole() }}
        </div>
      </div>
    </div>

    <div class="border-t border-gray-200 mb-4"></div>

    <!-- Menu items -->
    <div class="user-menu-items space-y-1">
      @for (item of userMenuItems; track item.label) {
        @if (!item.separator) {
          <button
            [attr.data-testid]="
              'sidebar-user-menu-action-' + toTestId(item.label) + '-btn'
            "
            class="user-menu-item w-full flex items-center gap-3 px-3 py-2 text-left rounded-lg hover:bg-gray-100 transition-colors"
            (click)="handleMenuItemClick(item); userMenu.hide()"
          >
            <i [class]="item.icon" class="text-gray-500"></i>
            <span class="text-sm text-gray-700">{{
              item.label | translate
            }}</span>
          </button>
        }
      }
      <div class="user-menu" *ngIf="isUserMenuOpen()">
        <button
          data-testid="sidebar-user-profile-btn"
          type="button"
          class="user-menu-item w-full flex items-center gap-3 px-3 py-2 text-left rounded-lg hover:bg-gray-100 transition-colors bg-transparent border-none"
          (click)="onUserProfile()"
        >
          <i class="pi pi-user"></i>
          <span>User Profile</span>
        </button>
        <button
          data-testid="sidebar-user-settings-btn"
          type="button"
          class="user-menu-item w-full flex items-center gap-3 px-3 py-2 text-left rounded-lg hover:bg-gray-100 transition-colors bg-transparent border-none"
          (click)="onUserSettings()"
        >
          <i class="pi pi-cog"></i>
          <span>Settings</span>
        </button>
        <button
          data-testid="sidebar-user-sign-out-btn"
          type="button"
          class="user-menu-item w-full flex items-center gap-3 px-3 py-2 text-left rounded-lg hover:bg-gray-100 transition-colors bg-transparent border-none"
          (click)="onSignOut()"
        >
          <i class="pi pi-sign-out"></i>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </div>
</p-popover>
